import { http, HttpResponse } from "msw";

import { SCM_GITHUB_USER } from "./data";

export const scmHandlersStatic = [
  http.get("*/api/scm/deployments/:deploymentId/configs/:configId/check", () =>
    HttpResponse.json(
      { status: { ok: true, checked: undefined } },
      {
        status: 200,
      }
    )
  ),
  http.get("*/api/scm/deployments/:deploymentId/configs", () =>
    HttpResponse.json(
      { configs: [SCM_GITHUB_USER] },
      {
        status: 200,
      }
    )
  ),
];
